import { passwordLogin } from "@/apis/auth.api";
import { RememberMeKey, TokenKey } from "@/constants";
import { useMutation } from "@tanstack/react-query";
import type { FormProps } from "antd";
import { Form } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRememberMe } from "../useRememberMe";

export type FieldType = {
  username?: string;
  password?: string;
  remember?: boolean;
};

export function useLoginBehavior() {
  const navigate = useNavigate();
  const [form] = Form.useForm<FieldType>();

  const onFinish: FormProps<FieldType>["onFinish"] = (values) => {
    setChecked(values.remember!);
    login({
      username: values.username!,
      password: values.password!,
      readMe: values.remember!,
    });
  };

  const { mutate: login, isPending } = useMutation({
    mutationFn: (data: {
      username: string;
      password: string;
      readMe: boolean;
    }) => passwordLogin(data),
    onSuccess: (res) => {
      localStorage.setItem(TokenKey, res.data.data.token);
      sessionStorage.setItem("user", JSON.stringify(res.data.data));
      navigate("/");
    },
  });

  const [inititalValues, setInitialValues] = useState<FieldType>({
    remember: false,
  });

  const { checked, setChecked } = useRememberMe({
    storageKey: RememberMeKey,
  });

  useEffect(() => {
    const { username, password } = form.getFieldsValue();
    setInitialValues({
      username,
      password,
      remember: checked,
    });
  }, [checked, form]);

  useEffect(() => {
    form.resetFields();
  }, [inititalValues, form]);

  return {
    form,
    onFinish,
    checked,
    setRememberMeChecked: setChecked,
    inititalValues,
    login,
    loginPending: isPending,
  };
}
